import { render, staticRenderFns } from "./NosologiaProjectCard.vue?vue&type=template&id=54c5b0fc&scoped=true&"
import script from "./NosologiaProjectCard.vue?vue&type=script&lang=js&"
export * from "./NosologiaProjectCard.vue?vue&type=script&lang=js&"
import style0 from "./NosologiaProjectCard.vue?vue&type=style&index=0&id=54c5b0fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c5b0fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VIcon})
